import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import { SITE_URL } from "../../config/site";
import "./SuccessPage.css";

export default function CancelPage() {
  return (
    <>
      <SEO
        title="Pago cancelado | Imalandia"
        description="El pago no se ha completado. Puedes volver a Imalandia y retomar tu pedido."
        canonical={`${SITE_URL}/cancel`}
        noindex
      />

      <Header />

      <main className="checkout-result-page">
        <section className="checkout-result-card">
          <span
            className="checkout-result-icon"
            style={{ background: "#dc2626" }}
          >
            ×
          </span>

          <h1>Pago cancelado</h1>

          <p>
            El pedido no se ha completado. Puedes volver al editor e intentarlo
            de nuevo cuando quieras.
          </p>

          <Link to="/" className="checkout-result-link">
            Volver al inicio
          </Link>
        </section>
      </main>

      <Footer />
    </>
  );
}
